import { Polyline, PolylineProps } from "react-leaflet";

/** A dashed gray line from a waypoint to the route where the route doesn't reach it */
export const MissingRoutePolyline = ({
  positions,
}: {
  positions: PolylineProps["positions"];
}) => (
  <>
    <Polyline
      positions={positions}
      pathOptions={{ color: "black", opacity: 0.15, weight: 7 }}
      interactive={false}
    />
    <Polyline
      positions={positions}
      pathOptions={{ color: "white", opacity: 0.6, weight: 4 }}
      interactive={false}
    />
    <Polyline
      positions={positions}
      pathOptions={{
        color: "gray",
        opacity: 0.8,
        weight: 2,
        dashArray: "7,12",
      }}
      interactive={false}
    />
  </>
);
